import Vue from 'vue'
import Router, { RouteConfig } from 'vue-router'

import store from '@/store'
import { bus } from './main';

Vue.use(Router)

const routes: RouteConfig[] = [
	{
		path: '/',
		name: 'home'
	},
	{
		path: '/vraag/:questionId',
		name: 'question',
		children: [
			{
				path: 'antwoord',
				name: 'answer'
			}
		]
	},
	{
		path: '/resultaat',
		name: 'results'
	},
	{
		path: '*',
		redirect: { name: 'home'}
	}
]

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

router.beforeEach((to, from, next) => {
	bus.$emit('closeInfo')
	bus.$emit('togglePrivacyPanel', false)

	Vue.nextTick(() => {
		ga('send', 'pageview', to.fullPath, {
			anonymizeIp: true
		})

		if ('scrollRestoration' in history) {
			history.scrollRestoration = 'manual';
		}
		
		if ((to.name === 'question' || to.name === 'answer') && ((JSON.parse(to.params.questionId) > 0 && store.getters.data.questions.length >= JSON.parse(to.params.questionId))) && store.getters.userChoices.length >= (JSON.parse(to.params.questionId) - 1)) {
			if (to.name === 'answer') {
				if (store.getters.userChoices[JSON.parse(to.params.questionId) - 1] !== undefined) {
					document.title = `StamcelWijzer | Vraag ${to.params.questionId} | Antwoord`

					if (to.params.questionId === from.params.questionId) {
						store.dispatch('onAnswerScreen', {onAnswerScreen: true, fromSameQuestion: true})
					} else {
						store.dispatch('onAnswerScreen', {onAnswerScreen: true, fromSameQuestion: false})
					}
				} else {
					next({ name: 'question', params: { questionId: to.params.questionId } })
				}
			} else {
				document.title = `StamcelWijzer | Vraag ${to.params.questionId}`

				if (to.params.questionId === from.params.questionId) {
					store.dispatch('onAnswerScreen', {onAnswerScreen: false, fromSameQuestion: true})
				} else {
					store.dispatch('onAnswerScreen', {onAnswerScreen: false, fromSameQuestion: false})
				}
			}

			store.dispatch('setCurrentScreen', JSON.parse(to.params.questionId))
	
			next()
		} else if (to.name === 'results' && store.getters.userChoices.length === store.getters.data.questions.length) {
			document.title = 'StamcelWijzer | Resultaat'

			store.dispatch('userOnResultScreen', true)
			store.dispatch('setCurrentScreen', (store.getters.userChoices.length + 1))
	
			next()
		} else if (to.name === 'home') {
			document.title = 'StamcelWijzer'

			store.dispatch('userOnResultScreen', true)
			store.dispatch('setCurrentScreen', 0)
	
			next()
		} else {
			next({ name: 'home'})
		}
	})
})

export default router
